'use client';

import { Locale } from '@core/constants/locales.constants';
import { AccordionBlock as AccordionBlockType } from '@graphql/__generated__/graphql';
import { UseClient } from '@stadionhq-v3/base-ui';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { accordionBlockTransform } from '@utils/transforms/components';
import AccordionBlock from '@components/v3/organisms/accordion-block';
import { RteDictionary } from '@components/helpers/contentful-rich-text-render';

export type RenderAccordionBlockProps = {
  locale?: Locale;
  props: CleanContentful<AccordionBlockType>;
  dictionary: RteDictionary;
};

const RenderAccordionBlock = ({
  props,
  dictionary,
}: RenderAccordionBlockProps) => (
  <UseClient>
    <AccordionBlock {...accordionBlockTransform(props, dictionary)} />
  </UseClient>
);

export default RenderAccordionBlock;
